import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soy-free",
  "use": "icon-soy-free-usage",
  "viewBox": "0 0 131 131",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 131 131\" id=\"icon-soy-free\"><g transform=\"translate(1.875 1.766)\" fill=\"none\" fill-rule=\"evenodd\"><circle stroke=\"currentColor\" stroke-width=\"2\" cx=\"63.625\" cy=\"63.625\" r=\"63.625\" /><path fill=\"currentColor\" d=\"m87.625 64.625-35 24v-48z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol